<template>
    <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="deveMostarModalReordenacao">
        <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
            <v-card-title class="primary modal-title" primary-title>
                <span>Reordenação de documento</span>
                <v-spacer></v-spacer>
                <v-btn flat depressed @click="fecharModalReordenacao">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-layout class="d-flex">
                    <v-flex xs12>
                        <p><strong class="text--secondary">Documento:</strong> {{  documento.nome }}</p>
                    </v-flex>
                </v-layout>
                <v-layout class="d-flex">
                    <v-flex xs12 md6>
                        <p><strong class="text--secondary">Sequencial Atual:</strong> {{  documento.numeroSequencial }}</p>
                    </v-flex>
                    <v-flex xs12 md6>
                        <p><strong class="text--secondary">Primeira página:</strong> {{  documento.primeiraPagina }}</p>
                    </v-flex>
                    <v-flex xs12 md6>
                        <p><strong class="text--secondary">Última página:</strong> {{  documento.ultimaPagina }}</p>
                    </v-flex>
                </v-layout>
                <v-layout class="d-flex">
                    <v-flex xs12>
                        <v-select v-model="novaSequencia"
                                  :items="sequencias"
                                  label="Escolha a nova sequencial" dense outlined
                                  key="Nova-Sequencial"
                                  :error-messages="errors.collect('Nova Sequencial')"
                                  v-validate="'required'"
                                  :name="'Nova Sequencial'"/>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions class="py-2 px-3">
                <v-btn color="botao-cancelar-color" id="botaoCancelarAssinaturas" outline flat @click="fecharModalReordenacao">
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaoConfirmarAssinaturas" color="primary" depressed @click="lancarEventoReorndenacao">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'ModalReordenacaoDocumento',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['documento', 'sequencias', 'deveMostarModalReordenacao'],
    data() {
        return {
            novaSequencia: null,
        }
    },
    computed: {
        Modal() {
            return Modal
        }
    },
    methods: {
        async lancarEventoReorndenacao() {
            await this.validarPreenchimento()
            this.$emit('eventoReordenarDocumento', this.novaSequencia)
            this.limparCampos()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Nova Sequencial')
            if (!estaValidado) {
                throw new Error('Por gentileza, escolha uma nova sequência.')
            }
        },
        fecharModalReordenacao() {
            this.$emit('eventoFecharModalReordenacao')
            this.limparCampos()
        },
        limparCampos() {
            this.$validator.reset()
            this.novaSequencia = null
        }
    }
}
</script>

<style scoped lang="stylus">

</style>